class SwatchSelects extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.variantJsonScript = document.getElementById(`variant-json-${this.productId}`);
    this.addEventListener('click', this.onSwatchClick.bind(this));
  }

  onSwatchClick(event) {
    const swatch = event.target.closest('.visual-swatch');
    if (!swatch) return;
    this.selectSwatch(swatch, event);
  }

  selectSwatch(swatch, event = null) {
    const variantData = swatch.getAttribute('data-variant');
    if (!variantData) return;

    const variant = JSON.parse(variantData);
    
    // 🔹 Update inline JSON
    if (this.variantJsonScript) {
      this.variantJsonScript.textContent = variantData;
    }
    
    // 🔹 Update swatch UI
    this.querySelectorAll('.visual-swatch').forEach(s => s.classList.remove('selected'));
    swatch.classList.add('selected');

    // 🔹 Update Price
    this.updatePrice(variant);

    // 🔹 Update Quantity UI
    // this.updateQuantityWrapper(variant);

    const productCard = this.closest('.product-card-wrapper');
    if (!productCard) return;

    const quickAddBulk = productCard.querySelector('quick-add-bulk');
    const newVariantId = variant.id.toString();

    if (!quickAddBulk) return;
    const quantityInput = quickAddBulk.querySelector('quantity-input');
    const inputEl = quantityInput?.querySelector('input.quantity__input');
    
    if (inputEl) {

      // 🔹 Special handling for "case"
      const quantityAttr = parseInt(swatch.getAttribute('data-quantity'), 10) || 0;
      const isCase = variant.title?.toLowerCase() === 'case';
      let maxQuantity = Infinity;
      if (isCase) {
        maxQuantity = Math.floor(quantityAttr / 12);
        inputEl.setAttribute('max', maxQuantity);
      }else{
        inputEl.setAttribute('max', quantityAttr);
      }
      
      // const quantityAttr = parseInt(swatch.getAttribute('data-quantity'), 10) || 0;
      // const isCase = variant.title?.toLowerCase() === 'case';
      console.log('variant===>',variant.available)
      const isUnavailable = !variant.available || (isCase && maxQuantity < 1);
      const plusBtn = quantityInput?.querySelector('button[name="plus"]');
      const minusBtn = quantityInput?.querySelector('button[name="minus"]');
      if (isUnavailable) {
        if (plusBtn) {
          plusBtn.classList.add('disabled');
          plusBtn.setAttribute('disabled', 'disabled');
        }
        inputEl.classList.add('disabled');
        inputEl.setAttribute('disabled', 'disabled');
        if (!swatch.classList.contains('visually-disabled')) {
          swatch.classList.add('visually-disabled');
        }
      } else {
        if (plusBtn) {
          plusBtn.classList.remove('disabled');
          plusBtn.removeAttribute('disabled');
        }
        inputEl.classList.remove('disabled');
        inputEl.removeAttribute('disabled');
        swatch.classList.remove('visually-disabled');
      }
      inputEl.setAttribute('data-index', newVariantId);
      inputEl.setAttribute('data-quantity-variant-id', newVariantId);
      inputEl.setAttribute('data-target', `quantity-input-${newVariantId}`);
      delete inputEl.dataset.pickupMax;
      if (plusBtn) plusBtn.setAttribute('data-target', `increment-${newVariantId}`);
      if (minusBtn) minusBtn.setAttribute('data-target', `decrement-${newVariantId}`);
      
      inputEl.id = `Quantity-${newVariantId}`;
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          console.log('cart', cart);
          const item = cart.items.find(i => i.variant_id === variant.id);
          const quantity = item ? item.quantity : 0;
          inputEl.value = quantity;
          inputEl.setAttribute('data-cart-quantity', quantity);
          const max = parseInt(inputEl.getAttribute('max') || '', 10);
          if (plusBtn && !Number.isNaN(max)) {
            if (quantity >= max) {
              plusBtn.classList.add('disabled');
              plusBtn.setAttribute('disabled', 'disabled');
            } else {
              plusBtn.classList.remove('disabled');
              plusBtn.removeAttribute('disabled');
            }
          }
          quickAddBulk.refreshPickupAvailability?.(true);
        })
        .catch(err => {
          console.error('Failed to fetch cart data:', err);
        });
    }

    // 🔹 Publish event
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target: swatch,
          selectedOptionValues: [variant.id],
        }
      });
    }
  }
  
  updatePrice(variant) {
    const productCard = this.closest('.product-card-wrapper');
    if (!productCard) return;

    const priceWrappers = productCard.querySelectorAll('.price');
    if (!priceWrappers.length) return;

    let allVariants = [];

    try {
      allVariants = JSON.parse(this.variantJsonScript?.textContent || '[]');

      if (!Array.isArray(allVariants) || allVariants.length === 0) {
        const variantNodes = productCard.querySelectorAll('[data-variant]');
        allVariants = Array.from(variantNodes).map(node => JSON.parse(node.getAttribute('data-variant')));
      }
    } catch (e) {}

    const allPrices = allVariants.map(v => v.price / 100);
    const minPrice = Math.min(...allPrices);

    const selectedPrice = variant.price / 100;
    const compareAtPrice = variant.compare_at_price ? (variant.compare_at_price / 100) : null;
    const isOnSale = compareAtPrice && compareAtPrice > selectedPrice;
    const isPriceRange = allPrices.some(price => price !== selectedPrice);

    priceWrappers.forEach((priceWrapper) => {
      const regularPriceEls = priceWrapper.querySelectorAll('.price-item--regular');
      const salePriceEls = priceWrapper.querySelectorAll('.price-item--sale');

      regularPriceEls.forEach((el) => {
        if (el.closest('.price__sale')) {
          el.textContent = isOnSale && compareAtPrice ? `$${compareAtPrice.toFixed(2)}` : '';
        } else {
          el.textContent = !isOnSale
            ? (selectedPrice === minPrice && isPriceRange
                ? `From $${selectedPrice.toFixed(2)}`
                : `$${selectedPrice.toFixed(2)}`)
            : '';
        }
      });

      salePriceEls.forEach((el) => {
        el.textContent = isOnSale
          ? (selectedPrice === minPrice && isPriceRange
              ? `From $${selectedPrice.toFixed(2)}`
              : `$${selectedPrice.toFixed(2)}`)
          : '';
      });

      const regularBlock = priceWrapper.querySelector('.price__regular');
      const saleBlock = priceWrapper.querySelector('.price__sale');

      if (regularBlock) regularBlock.style.display = isOnSale ? 'none' : '';
      if (saleBlock) saleBlock.style.display = isOnSale ? '' : 'none';

      priceWrapper.classList.toggle('price--on-sale', isOnSale);
    });
  }
}

customElements.define('swatch-selects', SwatchSelects);
